<div mat-dialog-title>
  <h2>{{"auth." + (data.action == requiredaction.ClockIn ? 'Clock-In' : 'Clock-Out') | translate}}</h2>
  <button mat-icon-button class="close" mat-dialog-close [disabled]="loading">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="mat-dialog-body">

    <form [formGroup]="formGroup">

      <div class="fields-group">

        <div [hidden]="restaurants.length == 1 || data.restaurantId">
          <mat-form-field class="mb-3" hideRequiredMarker>
            <mat-label>{{ 'restaurant.Restaurant' | translate }}</mat-label>
            <mat-select formControlName="restaurant" (selectionChange)="restaurantChanged()">
              <mat-option *ngFor="let restaurant of restaurants" [value]="restaurant">
                {{restaurant.name}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('restaurant', 'required')">
              {{ 'forms.Required' | translate }}</mat-error>
          </mat-form-field>
        </div>

        <mat-form-field class="mb-3" [hidden]="!isTillRequired" hideRequiredMarker>
          <mat-label *ngIf="data.action == requiredaction.ClockIn">{{ 'auth.Initial Cash' | translate }}</mat-label>
          <mat-label *ngIf="data.action == requiredaction.ClockOut">{{ 'auth.Total cash drawer' | translate }}</mat-label>
          <input matInput formControlName="amount" maxlength="10" [required]="isTillRequired">
          <mat-error *ngIf="hasError('amount', 'required')">
            {{ 'forms.Required' | translate }}</mat-error>
          <mat-error *ngIf="hasError('amount', 'pattern')">
              {{ 'forms.Invalid value' | translate }} - {{'forms.Price accept only two digits of decimal' | translate}}
          </mat-error>
        </mat-form-field>

      </div>

      <p *ngIf="
        selectedRest?.attendancefeature
        && (selectedRest?.requiredaction == requiredaction.ClockOut)">
        {{"auth.Clock-In" | translate}}: <span class="fontSemiBold">{{selectedRest?.lastClockIn | date:'d MMM, y - h:mm a'}}</span>
      </p>

      <div class="row">
        <div class="col-12 mt-4">
          <button mat-raised-button
            class="w-100 py-3 font-20" color="primary"
            (click)="submitClock()"
            [class.loading]="loading"
            [disabled]="loading">
            <ng-container *ngIf="canContinue">{{"forms.Continue" | translate}}</ng-container>
            <ng-container *ngIf="!canContinue">
              {{"auth." + (data.action == requiredaction.ClockIn ? 'Clock-In' : 'Clock-Out') | translate}}
            </ng-container>
          </button>
        </div>

        <div class="col-12 mt-4">
          <button mat-button type="button" class="w-100 btn-grey py-3 font-20" mat-dialog-close [disabled]="loading">
            {{"forms.Cancel" | translate}}
          </button>
        </div>
      </div>

    </form>
  </div>
</mat-dialog-content>

<!-- <mat-dialog-actions>
  <button mat-button type="button" class="btn-grey">{{"forms.Cancel" | translate}}</button>

  <button mat-raised-button color="primary">
    {{"forms.Save" | translate}}
  </button>
</mat-dialog-actions> -->
